export default __webpack_public_path__ + "static/media/841.5be3ab86.png";